import { Resolution } from 'src/domains/calculators/utilities/types';

/**
 * Converts a resolution object to a formatted text string
 * @param resolution - The resolution as {width, height}
 * @returns Formatted string like "1920 X 1080"
 */
export const resolutionAsText = ({ width, height }: Resolution): string =>
  `${width} X ${height}`;
